var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"hidden bg-white md:block fixed bottom-1 left-1 border-2 border-purple-400 rounded-lg",attrs:{"src":_vm.twitchUrl,"height":"300","width":"480","frameborder":"0","scrolling":"no","allowfullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }